import type { RouteObject } from "react-router";

import { Outlet } from "react-router";
import { lazy, Suspense } from "react";

import { CONFIG } from "src/global-config";
import { DashboardLayout } from "src/layouts/dashboard";

import { LoadingScreen } from "src/components/loading-screen";

import { AuthGuard } from "src/auth/guard";

import { usePathname } from "../hooks";

// ----------------------------------------------------------------------

const DashboardPage = lazy(() => import("src/pages/dashboard/dashboard"));
const UserPage = lazy(() => import("src/pages/dashboard/user"));
const CategoryPage = lazy(() => import("src/pages/dashboard/category"));
const PrayerPage = lazy(() => import("src/pages/dashboard/prayer"));
const ChangePassword = lazy(
  () => import("src/pages/dashboard/change-password")
);
const TagPage = lazy(() => import("src/pages/dashboard/tag"));
const ReviewPage = lazy(() => import("src/pages/dashboard/review"));

// ----------------------------------------------------------------------

function SuspenseOutlet() {
  const pathname = usePathname();
  return (
    <Suspense key={pathname} fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  );
}

const dashboardLayout = () => (
  <DashboardLayout>
    <SuspenseOutlet />
  </DashboardLayout>
);

export const dashboardRoutes: RouteObject[] = [
  {
    path: "/",
    element: CONFIG.auth.skip ? (
      dashboardLayout()
    ) : (
      <AuthGuard>{dashboardLayout()}</AuthGuard>
    ),
    children: [
      { path: "dashboard", element: <DashboardPage />, index: true },
      { path: "users", element: <UserPage /> },
      { path: "categories", element: <CategoryPage /> },
      { path: "prayer", element: <PrayerPage /> },
      { path: "tags", element: <TagPage /> },
      { path: "reviews", element: <ReviewPage /> },
      { path: "change-password", element: <ChangePassword /> },
      // {
      //   path: 'group',
      //   children: [
      //     { element: <PageFour />, index: true },
      //     { path: 'five', element: <PageFive /> },
      //     { path: 'six', element: <PageSix /> },
      //   ],
      // },
    ],
  },
];
